/*
Trigger Event

Triggers a specified event on a target element

### Html Attributes

```
	data-trigger-event
	data-trigger-event--on="event on this element"
	data-trigger-event--target-selector="target element selector"
	data-trigger-event--event="event to trigger on target element"
```

Markup:
<form id="site-search">...</form>
<button
	type="button"
	class="button button--transparent"
	data-trigger-event
	data-trigger-event--on="click"
	data-trigger-event--target-selector="#site-search"
	data-trigger-event--event="submit"
	>
	Submit other form
</button>

*/
import $ from 'jquery';

/* global $:true */
import debug from 'debug';

const MODULE_NAME = 'plugins/trigger-event';
const log = debug(MODULE_NAME);

log('registerd');

class TriggerEvent {
	constructor(element, options) {
		log('element', element);
		log('options', options);
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.events = this.options.event.split(',');

		this.target = this.selectors.selectTarget(
			this.options.targetSelector,
			this.$element
		);

		log('ready', this.element);
		this.watch();
	}

	watch() {
		this.$element.on(this.options.on, this.triggerAll.bind(this));
	}

	triggerAll(){
		this.events.forEach(this.trigger.bind(this));
	}

	trigger(event) {
		if (!this.target.length) {
			log(`Event target: "${this.options.targetSelector}" not found. Aborting.`);
			return true;
		}

		// opt into using navite events
		if (this.options.using == "native") {
			const triggeredEvent = new CustomEvent(event.trim(), {
				bubbles: true,
				cancelable: true,
				// detail: {}
			});
			this.target[0].dispatchEvent(triggeredEvent);
		} else {
			this.target.trigger(event.trim());
		}
	}
}

TriggerEvent.DEFAULTS = {
	on: 'click',
	targetSelector: '(self)',
	using: 'jquery'
};

export default TriggerEvent;
//plugin(PLUGIN_NAME, TriggerEvent);



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__trigger-event/plugin.js